import { render, staticRenderFns } from "./CourseFormTermsBox.vue?vue&type=template&id=6a6514df&scoped=true&"
import script from "./CourseFormTermsBox.vue?vue&type=script&lang=ts&"
export * from "./CourseFormTermsBox.vue?vue&type=script&lang=ts&"
import style0 from "./CourseFormTermsBox.vue?vue&type=style&index=0&id=6a6514df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6514df",
  null
  
)

export default component.exports